import React, { useState, useEffect } from 'react';
import { Button, Container, FormControl, InputLabel, Box, Modal, MenuItem, Select, AppBar, Toolbar, Typography, Paper, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddDesignation = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'
  const [departmentName, setDepartmentName] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const [designationName, setDesignationName] = useState('');
  const [data, setData] = useState([]);
  const [department, setDepartment] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  let navigate = useNavigate();

  const fetchDepartmentData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;

      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Department/DepartmentName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const departmentData = await response.json();
        setDepartment(Array.isArray(departmentData) ? departmentData : []);
      } else {
        console.error('Failed to fetch department data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  useEffect(() => {
    fetchDepartmentData();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Designation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": sessionStorage.getItem('token')
        },
        body: JSON.stringify({
          "deptId": departmentId,
          "designationName": designationName
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setLoadingBarProgress(100);
        
        // Check the status field in the response
        if (responseData.status === 'Failed!' || responseData.status === 'failed') {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'Designation Added Successfully');
        }
        
        setModalOpen(true);
        if (responseData.status !== 'Failed!' && responseData.status !== 'failed') {
          setDesignationName('');
          setDepartmentName('');
          setDepartmentId('');
        }
      } else {
        setLoadingBarProgress(0);
        const responseData = await response.json();
        setModalType('error');
        setModalMessage(responseData.msg || 'Unable to add Designation');
        setModalOpen(true);
      }
    } catch (error) {
      console.error("API request error:", error);
      setLoadingBarProgress(0);
      setModalType('error');
      setModalMessage('An error occurred. Please try again later.');
      setModalOpen(true);
    }
  };

  const handleCancel = () => {
    setDepartmentName("")
    setDesignationName("");
  };



  const handleDelete = (index) => {
    const updatedData = [...data];
    updatedData.splice(index, 1);
    setData(updatedData);
  };

  return (
    <Container mt={4}>

      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Designation
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <FormControl fullWidth sx={{ marginBottom: 3 }}>
          <InputLabel id="departmentName-label">Department Name</InputLabel>
          <Select
            labelId="departmentName-label"
            id="departmentName"
            value={departmentName}
            label="Department Name"
            onChange={(e) => {
              const selectedDept = department.find(dept => dept.departmentName === e.target.value);
              if (selectedDept) {
                setDepartmentId(selectedDept.deptId);
                setDepartmentName(selectedDept.departmentName);
              }
            }}
          >
            {department.map((dept) => (
              <MenuItem key={dept.deptId} value={dept.departmentName}>
                {dept.departmentName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Designation Name"
          id="designationName"
          sx={{ marginBottom: 3 }}
          value={designationName}
          onChange={(e) => setDesignationName(e.target.value)}
        />
        <Tooltip title={!departmentName && "Select a Department" || !designationName && "Enter Designation Name"} arrow>
          <span><Button variant="contained" color="primary" disabled={!departmentName || !designationName} onClick={handleSave} sx={{ marginRight: 2 }}>
            SAVE
          </Button></span></Tooltip>
        <Button variant="contained" color="error" onClick={handleCancel}>
          RESET
        </Button>
      </Paper>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ 
            backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', 
            padding: '12px 16px' 
          }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1);
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* Snackbar removed - using modal instead */}
    </Container>
  );
};

export default AddDesignation;
